import React from 'react';
import ReactDOM from 'react-dom';
import EDP from '.';
import './sim';

ReactDOM.render(<EDP />, document.getElementById('ticketselection'));



// WEBPACK FOOTER //
// ./frontend/react/apps/edp/entry.js